import { getUrlParam } from '@tencent/vft-common/util';
import { getVuid } from '@tencent/vft-common/login';
export default {
  orderid: getUrlParam('orderid'),
  inviteVuid: getUrlParam('userid'),
  vuid: getVuid(),
  ptag: getUrlParam('ptag'),
  rem: parseFloat(document.documentElement.style.fontSize),
  optionSupported: 'scrollBehavior' in document.documentElement.style
};